<template lang="pug">
v-container(fluid)
  v-card(outlined)
    v-card-title.d-flex.justify-space-between
      span Opciones de Selección
      v-btn(color="primary" @click="openDialog()")
        v-icon(left) mdi-plus
        | Nueva Opción
    
    v-card-text
      v-data-table(
        :headers="headers"
        :items="selectionOptions"
        :loading="loading"
        :items-per-page="10"
      )
        template(v-slot:item.price="{ item }")
          | ${{ item.price.toFixed(2) }}
        template(v-slot:item.active="{ item }")
          v-switch(
            v-model="item.active"
            @change="updateOption(item)"
            dense
            inset
          )
        template(v-slot:item.actions="{ item }")
          v-btn(
            icon
            small
            @click="openDialog(item)"
          )
            v-icon mdi-pencil
          v-btn(
            icon
            small
            @click="confirmDelete(item)"
          )
            v-icon mdi-delete

  // Diálogo de confirmación para eliminar
  v-dialog(v-model="deleteDialog" max-width="400")
    v-card
      v-card-title ¿Eliminar opción de selección?
      v-card-text ¿Está seguro que desea eliminar esta opción de selección? Esta acción no se puede deshacer.
      v-card-actions
        v-spacer
        v-btn(text @click="deleteDialog = false") Cancelar
        v-btn(
          color="error"
          @click="deleteItem"
        ) Eliminar
        
  // Selection Option Dialog
  selection-option-form-dialog(
    v-model="dialog"
    :option="selectedOption"
    @save="saveOption"
  )
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SelectionOptionFormDialog from '@/components/admin/SelectionOptionFormDialog.vue'

export default {
  name: 'CustomizationSelectionOptions',
  
  components: {
    SelectionOptionFormDialog
  },

  data: () => ({
    dialog: false,
    deleteDialog: false,
    loading: false,
    headers: [
      { text: 'Nombre', value: 'name' },
      { text: 'Descripción', value: 'description' },
      { text: 'Precio', value: 'price' },
      { text: 'Activo', value: 'active' },
      { text: 'Acciones', value: 'actions', sortable: false }
    ],
    selectedOption: null,
    itemToDelete: null
  }),

  computed: {
    ...mapState({
      selectionOptions: state => state.selectionOptions.list
    })
  },

  methods: {
    ...mapActions({
      fetchOptions: 'selectionOptions/fetch',
      createOption: 'selectionOptions/create',
      updateOption: 'selectionOptions/update',
      deleteOption: 'selectionOptions/delete'
    }),

    openDialog(item = null) {
      this.selectedOption = item ? { ...item } : null
      this.dialog = true
    },

    async saveOption(optionData) {
      this.loading = true
      try {
        if (optionData._id) {
          await this.updateOption(optionData)
          this.$toast.success('Opción actualizada correctamente')
        } else {
          await this.createOption(optionData)
          this.$toast.success('Opción creada correctamente')
        }
      } catch (error) {
        this.$toast.error('Error al guardar la opción')
        console.error('Error:', error)
      } finally {
        this.loading = false
      }
    },

    confirmDelete(item) {
      this.itemToDelete = item
      this.deleteDialog = true
    },

    async deleteItem() {
      this.loading = true
      try {
        await this.deleteOption(this.itemToDelete._id)
        this.$toast.success('Opción eliminada correctamente')
        this.deleteDialog = false
      } catch (error) {
        this.$toast.error('Error al eliminar la opción')
        console.error('Error:', error)
      } finally {
        this.loading = false
        this.itemToDelete = null
      }
    }
  },

  async created() {
    this.loading = true
    try {
      await this.fetchOptions()
    } catch (error) {
      this.$toast.error('Error al cargar los datos')
      console.error('Error:', error)
    } finally {
      this.loading = false
    }
  }
}
</script>
